/**
 * Sage bus — tiny pub/sub bridging the current view and the SageDock.
 * TreeView registers the open tree + a refresh callback; the dock reads them so
 * agent tool actions operate on the right tree and refresh the graph live.
 */

interface SageContext {
  treeId?: string
  treeName?: string
  refresh?: () => void
}

let ctx: SageContext = {}
const listeners = new Set<() => void>()

export function setSageContext(next: SageContext) {
  ctx = next
  listeners.forEach(l => l())
}

export function clearSageContext() {
  ctx = {}
  listeners.forEach(l => l())
}

export function getSageContext(): SageContext {
  return ctx
}

export function subscribeSage(fn: () => void): () => void {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

// One-shot prompt hand-off: any view can queue a question and pop the dock open.
let pendingAsk: string | null = null

export function askSage(prompt: string) {
  pendingAsk = prompt
  window.dispatchEvent(new CustomEvent('sage:open'))
  listeners.forEach(l => l())
}

export function consumePendingAsk(): string | null {
  const p = pendingAsk
  pendingAsk = null
  return p
}
